import { CenterEvent } from '../../lib/types/models/center-event/center-event'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const resolveCenterEvent = async (centerEventId: number): Promise<CenterEvent> => {
  return restApiClient
    .url(constructApiUrl(API.centerEvents.resolve.url, { id: centerEventId }))
    .post<CenterEvent>()
}
